/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IUser = Models.IUser;

    export interface IAvatarModalScope extends ng.IScope {
        user: IUser;
        range: (max: number) => number[];
        modalClose: () => void;
        modalSave: (avatarIndex: number) => void;
    }

    export class AvatarModalController {
        public static templateURL: string = "decorators/modals/avatar-modal.html";
        public static ID: string = "#avatar-modal";
        public static $name: string = "avatarModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'user'];

        private $scope: IAvatarModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private $timeout: ng.ITimeoutService;

        /**
         * Constructor
         */
        constructor($scope: IAvatarModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    user: IUser) {

            this.$scope = $scope;
            this.close = close;
            this.$timeout = $timeout;
            this.$scope.user = user;

            this.$scope.range = (max: number): number[] => {
                return new Array(max);
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (avatarIndex: number): void => {
                if (avatarIndex < 10)
                    this.$scope.user.avatar = "0" + avatarIndex.toString();
                else if (avatarIndex >= 10)
                    this.$scope.user.avatar = avatarIndex.toString();
                else
                    this.$scope.user.avatar = "01";
                this.close(this.$scope.user);
            };
        }
    }
}